module.exports = __webpack_public_path__ + "img/mobile-menu-close.0b475bd4.svg";